import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

/**
 * Reusable stat card with optional sparkline trend
 * @param {string} label - Card label (uppercase)
 * @param {string|number} value - Primary display value
 * @param {string} sublabel - Optional sub-label below main label
 * @param {Array} sparkData - Optional array of {value} objects for sparkline
 * @param {string} className - Optional extra class (e.g. 'warning', 'danger')
 */
const StatCard = ({ label, value, sublabel, sparkData, className = '' }) => {
  // Determine sparkline color: green if trending up, red if down, gray if flat
  let sparkColor = '#9ca3af'; // gray
  if (sparkData && sparkData.length >= 2) {
    const first = sparkData[0].value;
    const last = sparkData[sparkData.length - 1].value;
    if (last > first) sparkColor = '#28a745';
    else if (last < first) sparkColor = '#dc3545';
  }

  return (
    <div className={`overview-card ${className}`}>
      <div className="number">{value}</div>
      {sparkData && sparkData.length > 1 && (
        <div style={{ width: 80, height: 24, margin: '4px auto' }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={sparkData}>
              <Line
                type="monotone"
                dataKey="value"
                stroke={sparkColor}
                strokeWidth={1.5}
                dot={false}
                isAnimationActive={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
      <div className="label">{label}</div>
      {sublabel && <div className="sublabel">{sublabel}</div>}
    </div>
  );
};

export default StatCard;
